"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_PATTERN = void 0;
exports.validateEmail = validateEmail;
exports.normalizeEmail = normalizeEmail;
/**
 * Validates email format
 *
 * @param value - Email to validate
 * @returns ValidationResult with isValid flag and optional error message
 */
function validateEmail(value) {
    if (!value || !value.trim()) {
        return { isValid: false, error: 'Email es requerido' };
    }
    const normalized = value.toLowerCase().trim();
    // Basic email pattern
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(normalized)) {
        return { isValid: false, error: 'Email inválido' };
    }
    return { isValid: true };
}
/**
 * Normalizes email to lowercase and trimmed
 *
 * @param value - Email to normalize
 * @returns Normalized email
 */
function normalizeEmail(value) {
    return value.toLowerCase().trim();
}
/**
 * Regex pattern for email validation
 * Can be used directly in form libraries that accept regex
 */
exports.EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
